import { Grid } from '@mui/material';
import { useState } from 'react'
import { getDateWithoutTime, userFriendlyDate } from '../../../../../Helpers/DateFormatter';
import { DashboardService } from '../../../../Api/EmploymentEquity/Dashboard/DashboardService';
import { EmploymentEquityDashboardDto } from '../../../../Model/Dto/EmploymentEquity/Dashboard';
import { OccupationalLevelTypes } from '../../../../Model/Enum/BEE123Enums';
import { DashboardSectionType } from '../../../../Model/Enum/DashboardType';
import { GenderList } from '../../../../Model/Enum/MultiSelectOptions/GenderOptions';
import { IOptions, OccupationalLevelDisplayList, OccupationalLevelList } from '../../../../Model/Enum/MultiSelectOptions/OccupationallevelOptions';
import { RaceList } from '../../../../Model/Enum/MultiSelectOptions/RaceOptions';
import { removeWhiteSpaceAndHyphenChars } from '../../../../Model/helpers';
import { mapEmployeeHeadcountToPieChartData } from '../../../../Model/Mappers/EmploymentEquityMapper';
import { MDBox } from '../../MDBox';
import { MDTypography } from '../../MDTypography';
import { PieChart } from '../Base/PieChart/PieChart';
const hash = require("object-hash");

interface IProps {
  scorecardId?: string;
  scorecardTypeId?: string;
  fixedOccupationalLevel?: number;
  chartOptions?: any;
  dashboardType?: DashboardSectionType;
  dashboardLevelOnClick?: (chartLabel: string) => void;
  sourceScorecardIds?: string[];
}

export const EmployementEquity1PieChart = (props: IProps) => {
  const defaultCurrentSelectedOption: IOptions = !props.fixedOccupationalLevel
    ? { label: "All Occupational levels", value: "0" }
    : {
      label:
        OccupationalLevelList()[props.fixedOccupationalLevel].label,
      value: props.fixedOccupationalLevel.toString(),
    };
  const [OccupationalLevelOptionsList, setOccupationalLevelOptionsList] = useState<Array<IOptions>>(OccupationalLevelDisplayList());
  const [currentSelectedOptions, setCurrentSelectedOptions] = useState<IOptions>(defaultCurrentSelectedOption);
  const [counter, setCounter] = useState(0);

  const chartKey = `${counter}-${JSON.stringify(props.sourceScorecardIds ?? [])}`;

  const getPieChartData = (filterDate: Date) => {
    let SelectedGenderArray: Array<number> = [];
    let SelectedRaceArray: Array<number> = [];
    let SelectedOccupationLevelArray: Array<number> = [];

    GenderList.map((item) => SelectedGenderArray.push(parseInt(item.value)));
    RaceList.map((item) => SelectedRaceArray.push(parseInt(item.value)));

    if (parseInt(currentSelectedOptions.value) === 0) {
      OccupationalLevelList()
        .map((item: any) =>
          SelectedOccupationLevelArray.push(parseInt(item.value))
        );
    }
    else if(parseInt(currentSelectedOptions.value) === OccupationalLevelTypes.Top_Management ) {
      SelectedOccupationLevelArray = [
        OccupationalLevelTypes.Executive_Director,
        OccupationalLevelTypes.Other_Executive_Management
      ];
    }
    else {
      SelectedOccupationLevelArray = [
        parseInt(currentSelectedOptions.value)
      ];
    }

    const data: EmploymentEquityDashboardDto.EmployeeHeadcountRequest = {
      scorecardId: props.scorecardId,
      occupationLevelIds: SelectedOccupationLevelArray,
      raceIds: SelectedRaceArray,
      genderIds: SelectedGenderArray,
      filterDate: filterDate,
      sourceScorecardIds: props.sourceScorecardIds ? props.sourceScorecardIds : undefined
    }

    return DashboardService.GetEmployeeHeadCount(data)
      .then(
        mapEmployeeHeadcountToPieChartData(
          parseInt(currentSelectedOptions.value), props.chartOptions.isPowerPointPrint
        )
      );

  }

  const filterDate = () => {
    return props?.chartOptions?.filterDate ?? getDateWithoutTime(new Date());
  }

 const updateOccupationalLevelFilter = (e: any) => {
    e.persist();
    setCurrentSelectedOptions({
      value: e.target.value,
      label: e.target.label,
    })
    getPieChartData(filterDate());
  };

  const currentFilterDate = filterDate();
  const hashObj = {
    currentSelectedOption: currentSelectedOptions.value,
    currentFilterDate
  }
  const hashString = hash(hashObj);
  return (
    <>
      {!props.fixedOccupationalLevel && (
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <MDTypography ml={1} variant="subtitle1">Occupational Level Filter:</MDTypography>
          </Grid>

          <Grid item xs={4}>
            <select
              placeholder="Please select"
              value={currentSelectedOptions.value}
              onChange={(e: any) => 
                updateOccupationalLevelFilter(e)
              }
            >
              <option value="0">All Occupational levels</option>
              {OccupationalLevelOptionsList != null &&
                OccupationalLevelOptionsList.length > 0 ? (
                OccupationalLevelOptionsList.map((opt, index) => {
                  return (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  );
                })
              ) : (
                <option>No Items</option>
              )}
            </select>
          </Grid>
        </Grid>
      )}
      <MDBox sx={{ margin: 1 }}>
        <PieChart
          key={chartKey}
          hash={hashString}
          isPowerpointPrint={props.chartOptions.isPowerPointPrint !== undefined ? props.chartOptions.isPowerPointPrint : false}
          fetchData={() => getPieChartData(currentFilterDate)}
          onSegmentClick={(label: string) => {
            if (props.dashboardLevelOnClick) {
              if (
                props.fixedOccupationalLevel == null &&
                currentSelectedOptions?.value == null
              ) {
                props.dashboardLevelOnClick(label);
                return;
              }

              let occupationName : string | undefined = "";
              if (props.fixedOccupationalLevel){
                occupationName = OccupationalLevelList()[props.fixedOccupationalLevel].label;
              }
              if (currentSelectedOptions?.value){
                let occupationLevel = OccupationalLevelDisplayList().filter(option => {
                  if (option.value === currentSelectedOptions.value){
                    return option.label;
                  }
                })[0];
                occupationName = occupationLevel ? occupationLevel.label : "";
              }
              const newLabel =
                label +
                "|" +
                removeWhiteSpaceAndHyphenChars(occupationName ?? ""); // Keep dis, k thnx bye

              props.dashboardLevelOnClick(newLabel);
            }
          }}
        />
        {
          (filterDate() != null) &&
          // <i className="bottom-of-chart">as at {userFriendlyDate(props.chartOptions?.filterDate)}</i>
          <span className="bottom-of-chart inline-block"><i style={{ color: 'black' }}>as at </i> &nbsp;<b>{userFriendlyDate(props.chartOptions?.filterDate)}</b></span>
        }
      </MDBox>
    </>
  )
};


